import { Text, Center, Box, FlatList } from 'native-base'
import { ListRenderItem, StyleSheet } from 'react-native'

import { Icon } from './Icon'
import { LoadingState } from './LoadingState'
import { PointsHistoryTile, TILE_HEIGHT } from './PointsHistoryTile'
import { Spacer } from './atoms/Spacer'

import { useCallback, useMemo, useTranslation } from '~hooks'
import { usePointsHistory } from '~query-hooks'
import { PointsHistoryItem } from '~types/pointsHistory'
import { noop } from '~utils'

export const PointsHistoryList = ({
  onRefresh = noop,
  refreshing = false,
}: {
  onRefresh: () => void
  refreshing: boolean
}) => {
  const { t } = useTranslation()
  const keyExtractor = useCallback((_: PointsHistoryItem, index: number) => String(index), [])

  const { pointsHistory, isFetchingPointsHistory } = usePointsHistory()

  const renderItem: ListRenderItem<PointsHistoryItem> = useCallback(
    // TODO: adjust and map data properly if BE data is available
    ({ item }: { item: PointsHistoryItem }) => (
      <Box px="4">
        <PointsHistoryTile {...item} />
      </Box>
    ),
    []
  )

  const ListEmptyComponent = useMemo(() => {
    if (isFetchingPointsHistory) {
      return <LoadingState />
    }
    return (
      <Center flexGrow={1}>
        <Icon name="vip-diamond-line" size={50} color="inactive" />
        <Text bold mt="4" color="inactive" fontSize="2xl">
          {t('common.no_coins_yet')}
        </Text>
      </Center>
    )
  }, [isFetchingPointsHistory, t])

  const spacerItem = useCallback(() => <Spacer y="2" />, [])

  return (
    <FlatList
      contentContainerStyle={styles.flatList}
      ListEmptyComponent={ListEmptyComponent}
      data={pointsHistory}
      keyExtractor={keyExtractor}
      ItemSeparatorComponent={spacerItem}
      onRefresh={onRefresh}
      refreshing={refreshing}
      renderItem={renderItem}
      showsVerticalScrollIndicator={false}
    />
  )
}
const styles = StyleSheet.create({
  flatList: {
    flexGrow: 1,
    paddingBottom: TILE_HEIGHT / 2,
    paddingTop: 16,
  },
})
